<ng-container *ngIf="isAuthenticated">
  <app-navbar
    (signOutEmitter)="signOut()"
    (loadedEmitter)="onLoaded()"
    [email]="email"
    [user]="user"
  >
  </app-navbar>

  <ng-container *ngIf="loading">
    <app-dc-loading> Initializing... </app-dc-loading>
  </ng-container>
</ng-container>
<router-outlet></router-outlet>
<div class="app-version">
  <div class="environment">
    {{ environment }}
  </div>
  Build Number: {{ appBuildNumber }}<br />
  Build Date: {{ appBuildDateString }}<br />
  Version: {{ appVersion.substring(0, 10) }}<br />
</div>
